// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const DoubleChevronRight: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
                <path d="M12.482 12.029c.002.397-.154.778-.433 1.06l-5.972 5.972a1.5 1.5 0 0 1-2.12-2.12l4.941-4.912-4.747-4.926a1.492 1.492 0 1 1 2.15-2.06l5.763 5.972c.263.272.412.635.418 1.014z" />
                <path d="M20.482 12.029c.002.397-.154.778-.433 1.06l-5.972 5.972a1.5 1.5 0 0 1-2.12-2.12l4.941-4.912-4.747-4.927a1.493 1.493 0 1 1 2.149-2.06l5.763 5.972c.264.273.413.636.419 1.015z" />
            </g>
        </svg>
    );
};

export const DoubleChevronRightOffset: IconOffset = {
    vertical: 20,
    horizontal: 15,
};

export default React.memo(DoubleChevronRight);
